// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DynamicSchedulesSnapshotsQueryVariables = Types.Exact<{
  input: Types.PlanScheduleSnapshotsInput;
}>;


export type DynamicSchedulesSnapshotsQuery = { __typename?: 'Query', planScheduleSnapshots: { __typename?: 'PlanScheduleSnapshotsResult', taskSnapshots: Array<{ __typename?: 'TaskSnapshot', id: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number, task: { __typename?: 'Task', id: string } }>, planMilestoneSnapshots: Array<{ __typename?: 'PlanMilestoneSnapshot', id: string, estStartDate?: Types.Scalars['Date']['input'] | null | undefined, estEndDate?: Types.Scalars['Date']['input'] | null | undefined, durationInDays: number, planMilestone: { __typename?: 'PlanMilestone', id: string } }> } };

export type DynamicSchedulesTaskSnapshot_TaskSnapshotFragment = { __typename?: 'TaskSnapshot', id: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number, task: { __typename?: 'Task', id: string } };

export type DynamicSchedulesMilestoneSnapshot_PlanMilestoneSnapshotFragment = { __typename?: 'PlanMilestoneSnapshot', id: string, estStartDate?: Types.Scalars['Date']['input'] | null | undefined, estEndDate?: Types.Scalars['Date']['input'] | null | undefined, durationInDays: number, planMilestone: { __typename?: 'PlanMilestone', id: string } };

export const DynamicSchedulesTaskSnapshot_TaskSnapshotFragmentDoc = gql`
    fragment DynamicSchedulesTaskSnapshot_TaskSnapshot on TaskSnapshot {
  id
  startDate
  endDate
  durationInDays
  task {
    id
  }
}
    `;
export const DynamicSchedulesMilestoneSnapshot_PlanMilestoneSnapshotFragmentDoc = gql`
    fragment DynamicSchedulesMilestoneSnapshot_PlanMilestoneSnapshot on PlanMilestoneSnapshot {
  id
  estStartDate
  estEndDate
  durationInDays
  planMilestone {
    id
  }
}
    `;
export const DynamicSchedulesSnapshotsDocument = gql`
    query DynamicSchedulesSnapshots($input: PlanScheduleSnapshotsInput!) {
  planScheduleSnapshots(input: $input) {
    taskSnapshots {
      ...DynamicSchedulesTaskSnapshot_TaskSnapshot
    }
    planMilestoneSnapshots {
      ...DynamicSchedulesMilestoneSnapshot_PlanMilestoneSnapshot
    }
  }
}
    ${DynamicSchedulesTaskSnapshot_TaskSnapshotFragmentDoc}
${DynamicSchedulesMilestoneSnapshot_PlanMilestoneSnapshotFragmentDoc}`;

/**
 * __useDynamicSchedulesSnapshotsQuery__
 *
 * To run a query within a React component, call `useDynamicSchedulesSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicSchedulesSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicSchedulesSnapshotsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDynamicSchedulesSnapshotsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DynamicSchedulesSnapshotsQuery, DynamicSchedulesSnapshotsQueryVariables> & ({ variables: DynamicSchedulesSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DynamicSchedulesSnapshotsQuery, DynamicSchedulesSnapshotsQueryVariables>(DynamicSchedulesSnapshotsDocument, options);
      }
export function useDynamicSchedulesSnapshotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DynamicSchedulesSnapshotsQuery, DynamicSchedulesSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DynamicSchedulesSnapshotsQuery, DynamicSchedulesSnapshotsQueryVariables>(DynamicSchedulesSnapshotsDocument, options);
        }
export function useDynamicSchedulesSnapshotsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DynamicSchedulesSnapshotsQuery, DynamicSchedulesSnapshotsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DynamicSchedulesSnapshotsQuery, DynamicSchedulesSnapshotsQueryVariables>(DynamicSchedulesSnapshotsDocument, options);
        }
export type DynamicSchedulesSnapshotsQueryHookResult = ReturnType<typeof useDynamicSchedulesSnapshotsQuery>;
export type DynamicSchedulesSnapshotsLazyQueryHookResult = ReturnType<typeof useDynamicSchedulesSnapshotsLazyQuery>;
export type DynamicSchedulesSnapshotsSuspenseQueryHookResult = ReturnType<typeof useDynamicSchedulesSnapshotsSuspenseQuery>;
export type DynamicSchedulesSnapshotsQueryResult = Apollo.QueryResult<DynamicSchedulesSnapshotsQuery, DynamicSchedulesSnapshotsQueryVariables>;